import { ClientsService } from '../services'

export default (from, size, filters) => {
  return new Promise(async (resolve, reject) => {
    await ClientsService.read(from, size, filters)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}
